import React from 'react';
import ToolbarBigButton from '../ToolbarBigButton';
import ToolbarCollapse from '../ToolbarCollapse';
import ToolbarMarkdown from './ToolbarMarkdown';
import ToolbarShortcut from './ToolbarShortcut';
import ToolbarTip from './ToolbarTip';
import asColumns from '../../../utils/asColumns';

function ToolbarExpanded(_ref) {
  var editor = _ref.editor,
      buttons = _ref.buttons,
      selected = _ref.selected,
      hoverButton = _ref.hoverButton,
      onRendered = _ref.onRendered,
      command = _ref.command;
  React.useLayoutEffect(function () {
    return onRendered();
  });
  var columns = asColumns(buttons, 3);
  var canCollapse = command === undefined || command === null;
  return React.createElement("div", {
    className: "flexbox flexbox-column overflow-hidden",
    style: {
      maxHeight: 216
    }
  }, React.createElement("div", {
    className: "padding-smaller flexbox-grow flexbox scrollable"
  }, columns.map(function (buttons, index) {
    return React.createElement("div", {
      key: index,
      className: "flexbox-grow flexbox-basis-full height-full"
    }, buttons.map(function (button) {
      return React.createElement(ToolbarBigButton, {
        key: button.id,
        editor: editor,
        button: button,
        hover: button === hoverButton,
        selected: button === hoverButton && selected,
        withLabel: true
      });
    }));
  })), React.createElement("div", {
    className: "padding-horizontal-smaller flexbox flexbox-align-center shadow-normal",
    style: {
      minHeight: 32
    }
  }, React.createElement("div", {
    className: "flexbox-grow flexbox-basis-full padding-horizontal-small padding-vertical-smaller"
  }, hoverButton && (hoverButton.tip ? React.createElement(ToolbarTip, {
    tip: hoverButton.tip
  }) : React.createElement(ToolbarShortcut, {
    shortcut: hoverButton.shortcut
  }))), React.createElement("div", {
    className: "flexbox-grow flexbox-basis-full padding-left-small padding-vertical-smaller overflow-hidden"
  }, hoverButton && React.createElement(ToolbarMarkdown, {
    markdown: hoverButton.markdown
  })), React.createElement("div", {
    className: "flexbox-grow flexbox-basis-full flexbox flexbox-justify-end padding-horizontal-small"
  }, canCollapse && React.createElement(ToolbarCollapse, {
    editor: editor
  }))));
}

export default React.memo(ToolbarExpanded);